/**
 * MacroBaby — Correções de acessibilidade do widget Loop Subscriptions (Widget V1).
 *
 * A Loop não corrige o V1 do lado deles e os snippets loop-*.liquid são
 * regerados pelo app ("DO NOT modify"), então os ajustes ficam aqui, aplicados
 * sobre o DOM depois que o loop-widget.aio.min.js monta o widget:
 *
 *  1. Opções de compra (one-time / assinatura): o fieldset vira um radiogroup
 *     nomeado ("Purchase Options") e cada radio recebe um nome acessível com
 *     rótulo + selo de desconto + preço, atualizado quando a Loop troca
 *     variante/preço.
 *  2. Botão "Subscription details": vira um botão de verdade (foco, Enter/Espaço,
 *     Esc) com aria-expanded sincronizado com a abertura do diálogo.
 *  3. Ícones/imagens decorativos (relógio do tooltip, seta do balão, skeleton
 *     loader, imagens dentro do diálogo) são ocultados da tecnologia assistiva.
 *
 * Não depende de jQuery.
 */
(function () {
    'use strict';

    var CONTAINER_SELECTOR = '.loop-subscription-container';
    var ENHANCED_ATTR = 'data-mb-a11y';
    var OPEN_CLASS = 'mb-loop-tooltip--open';
    var uid = 0;

    function ensureId(el, prefix) {
        if (!el.id) {
            uid += 1;
            el.id = prefix + '-' + uid;
        }
        return el.id;
    }

    function cleanText(el) {
        return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    // Visível = nem o elemento nem algum ancestral (até `root`) está com display:none.
    function isShown(el, root) {
        for (var node = el; node && node !== root.parentNode; node = node.parentElement) {
            if (window.getComputedStyle(node).display === 'none') return false;
        }
        return true;
    }

    function hideFromAT(el) {
        el.setAttribute('aria-hidden', 'true');
        if (el.tagName.toLowerCase() === 'svg') el.setAttribute('focusable', 'false');
        if (el.tagName.toLowerCase() === 'img') {
            el.setAttribute('alt', '');
            el.setAttribute('role', 'presentation');
        }
    }

    function injectStyles() {
        if (document.getElementById('mb-loop-a11y-style')) return;
        var style = document.createElement('style');
        style.id = 'mb-loop-a11y-style';
        style.textContent =
            '.loop-tooltip.' + OPEN_CLASS + ' .loop-tooltiptext{visibility:visible}' +
            '.loop-tooltip-label[role="button"]:focus-visible{outline:2px solid currentColor;outline-offset:2px}';
        document.head.appendChild(style);
    }

    /* ---------- 3. Imagens decorativas ---------- */

    function hideDecorative(container) {
        container.querySelectorAll(
            '.loop-tooltip-image, .loop-tooltip-image svg, .loop-container-arrow'
        ).forEach(hideFromAT);

        // Imagens/ícones dentro do diálogo vêm do HTML configurado no app da Loop
        // e são sempre ilustrativos — o texto do diálogo carrega o conteúdo.
        container.querySelectorAll('.loop-tooltiptext img, .loop-tooltiptext svg').forEach(hideFromAT);

        // Qualquer outro <img>/<svg> do widget sem texto alternativo é decorativo.
        container.querySelectorAll('img:not([alt]), svg:not([aria-label]):not([aria-labelledby])').forEach(hideFromAT);

        // Skeleton loader fica fora do container, logo antes dele.
        var form = container.closest('form') || container.parentElement;
        if (form) {
            form.querySelectorAll('.loop-widget-skeleton-loader-container').forEach(hideFromAT);
        }
    }

    /* ---------- 1. Opções de compra ---------- */

    function labelPurchaseOptions(container) {
        var fieldset = container.querySelector('.loop-selling-plan-fieldset');
        if (!fieldset) return;

        // A <legend> da Loop está com display:none, então o grupo fica sem nome.
        var groupLabel = container.querySelector('.loop-purchase-options-label');
        fieldset.setAttribute('role', 'radiogroup');
        if (groupLabel && cleanText(groupLabel)) {
            fieldset.setAttribute('aria-labelledby', ensureId(groupLabel, 'mb-loop-options-label'));
        }

        fieldset.querySelectorAll('input[type="radio"][name="loop_purchase_option"]').forEach(function (radio) {
            var option = radio.closest('.loop-subscription-group, .loop-one-time-purchase-option');
            if (!option) return;

            var label = radio.id ? option.querySelector('label[for="' + radio.id + '"]') : null;
            var parts = [cleanText(label)];

            option.querySelectorAll(
                '.loop-subscription-group-discount-badge, ' +
                '.loop-subscription-group-price-amount, .loop-one-time-purchase-option-price-amount, ' +
                '.loop-subscription-group-price-quantity, .loop-one-time-purchase-option-price-quantity'
            ).forEach(function (el) {
                if (isShown(el, option)) parts.push(cleanText(el));
            });

            var name = parts.filter(Boolean).join(', ');
            if (name && radio.getAttribute('aria-label') !== name) {
                radio.setAttribute('aria-label', name);
            }
        });
    }

    /* ---------- 2. Botão do diálogo "Subscription details" ---------- */

    function setupTooltip(container) {
        var tooltip = container.querySelector('.loop-tooltip');
        var trigger = tooltip && tooltip.querySelector('.loop-tooltip-label');
        var panel = tooltip && tooltip.querySelector('.loop-tooltiptext');
        if (!trigger || !panel) return;

        // Não trocamos os ids existentes: a Loop usa #loop-tooltip-label para preencher o texto.
        var panelId = ensureId(panel, 'mb-loop-details-dialog');
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('tabindex', '0');
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', panelId);
        trigger.setAttribute('aria-expanded', 'false');
        panel.setAttribute('role', 'dialog');

        var pinned = false;
        var hovered = false;

        function sync() {
            var expanded = pinned || hovered;
            tooltip.classList.toggle(OPEN_CLASS, pinned);
            trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            if (cleanText(trigger)) panel.setAttribute('aria-label', cleanText(trigger));
        }

        function close(returnFocus) {
            pinned = false;
            hovered = false;
            sync();
            if (returnFocus) trigger.focus();
        }

        trigger.addEventListener('click', function () {
            pinned = !pinned;
            sync();
        });

        trigger.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                e.preventDefault();
                pinned = !pinned;
                sync();
            }
        });

        tooltip.addEventListener('keydown', function (e) {
            if ((e.key === 'Escape' || e.key === 'Esc') && (pinned || hovered)) {
                e.preventDefault();
                close(true);
            }
        });

        // O CSS da Loop abre o balão no :hover — refletimos isso no aria-expanded.
        tooltip.addEventListener('mouseenter', function () {
            hovered = true;
            sync();
        });
        tooltip.addEventListener('mouseleave', function () {
            hovered = false;
            sync();
        });

        // Fecha ao clicar fora ou quando o foco sai do componente.
        document.addEventListener('click', function (e) {
            if (pinned && !tooltip.contains(e.target)) close(false);
        });
        tooltip.addEventListener('focusout', function (e) {
            if (pinned && e.relatedTarget && !tooltip.contains(e.relatedTarget)) close(false);
        });

        sync();
    }

    /* ---------- Orquestração ---------- */

    function refresh(container) {
        hideDecorative(container);
        labelPurchaseOptions(container);
    }

    function enhance(container) {
        if (container.hasAttribute(ENHANCED_ATTR)) return;
        container.setAttribute(ENHANCED_ATTR, '');

        setupTooltip(container);
        refresh(container);

        // A Loop reescreve preço/selo e mostra/oculta grupos ao trocar variante.
        var scheduled = false;
        new MutationObserver(function () {
            if (scheduled) return;
            scheduled = true;
            requestAnimationFrame(function () {
                scheduled = false;
                refresh(container);
            });
        }).observe(container, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['class']
        });
    }

    function enhanceAll() {
        document.querySelectorAll(CONTAINER_SELECTOR).forEach(enhance);
    }

    function init() {
        injectStyles();
        enhanceAll();

        // Widgets que chegam depois (quick view, section rendering, editor do tema).
        var pending = false;
        new MutationObserver(function () {
            if (pending) return;
            pending = true;
            requestAnimationFrame(function () {
                pending = false;
                enhanceAll();
            });
        }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
